import KformComponent from '../kform-component';

export default class HtmlelementComponent extends KformComponent {
	/**
	 * @param {import('@knitiv/api-client-javascript').ComponentHtmlelement | undefined} settings
	 */
	constructor(settings = undefined) {
		super(settings);
		this.tag = settings?.tag ?? 'p';
		this.attrs = settings?.attrs ?? [];
		this.className = settings?.className ?? '';
		this.content = settings?.content ?? '';
	}
}
